import firebase from 'firebase/app';

const storage = () => firebase.storage();

storage.ref = (path) => firebase.storage().ref(path);

storage.getDownloadURL = (ref) => ref.getDownloadURL();

export default storage;
